import {
    GEO_DATA_REQUEST,
    GEO_DATA_SUCCESS,
    GEO_DATA_FAILURE,
    PROVIDER_DATA_REQUEST,
    PROVIDER_DATA_SUCCESS,
    PROVIDER_DATA_FAILURE,
    LOOKUP_DATA_REQUEST,
    LOOKUP_DATA_SUCCESS,
    LOOKUP_DATA_FAILURE,
    TEXT_DATA_REQUEST,
    TEXT_DATA_SUCCESS,
    TEXT_DATA_FAILURE,
    LOOKUP_REFERENCE_DATA_REQUEST,
    LOOKUP_REFERENCE_DATA_SUCCESS,
    LOOKUP_REFERENCE_DATA_FAILURE,
    SERVICE_DATA_REQUEST,
    SERVICE_DATA_SUCCESS,
    SERVICE_DATA_FAILURE

} from '../actions/commonDataActions';
import {combineReducers} from 'redux';
import moment from 'moment';

function lookupReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    lookupDataStore: {}
}, action) {
    switch (action.type) {
        case LOOKUP_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                loadTime: undefined,
                lookupDataStore: {}
            }
        case LOOKUP_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inError: false,
                loadTime: moment.utc().unix(),
                lookupDataStore: action.payload
            }
        case LOOKUP_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                loadTime: undefined,
                lookupDataStore: {}
            }
        default:
            return state;
    }
}

function textReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    textDataStore: {}
}, action) {
    switch (action.type) {
        case TEXT_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                loadTime: undefined,
                textDataStore: {}
            }
        case TEXT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inError: false,
                loadTime: moment.utc().unix(),
                textDataStore: action.payload
            }
        case TEXT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                loadTime: undefined,
                textDataStore: {}
            }
        default:
            return state;
    }
}

function providerReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    lookupDataStore: {}
}, action) {
    switch (action.type) {
        case PROVIDER_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                loadTime: undefined,
                providerDataStore: {}
            }
        case PROVIDER_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inError: false,
                loadTime: moment.utc().unix(),
                providerDataStore: action.payload
            }
        case PROVIDER_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                loadTime: undefined,
                providerDataStore: {}
            }
        default:
            return state;
    }
}

function geoDataReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    geoDataStore: {}
}, action) {
    switch (action.type) {
        case GEO_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                loadTime: undefined,
                geoDataStore: {}
            }
        case GEO_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inError: false,
                loadTime: moment.utc().unix(),
                geoDataStore: action.payload
            }
        case GEO_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                loadTime: undefined,
                geoDataStore: {}
            }
        default:
            return state;
    }
}

function lookupReferenceReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    lookupDataStore: {}
  }, action) {
    switch (action.type) {
      case LOOKUP_REFERENCE_DATA_REQUEST:
        return {
          ...state,
          loading: true,
          loadTime: undefined,
          lookupReferenceDataStore: {}
        }
      case LOOKUP_REFERENCE_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          inError: false,
          loadTime: moment.utc().unix(),
          lookupReferenceDataStore: action.payload
        }
      case LOOKUP_REFERENCE_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          loadTime: undefined,
          lookupReferenceDataStore: {}
        }
      default:
        return state;
    }
}

function serviceReducer(state = {
    loading: false,
    inError: false,
    loadTime: undefined,
    serviceDataStore: {}
  }, action) {
    switch (action.type) {
      case SERVICE_DATA_REQUEST:
        return {
          ...state,
          loading: true,
          loadTime: undefined,
          serviceDataStore: {}
        }
      case SERVICE_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          inError: false,
          loadTime: moment.utc().unix(),
          serviceDataStore: action.payload
        }
      case SERVICE_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          loadTime: undefined,
          serviceDataStore: {}
        }
      default:
        return state;
    }
  }


export default combineReducers({
    textData: textReducer,
    geoData: geoDataReducer,
    lookupData: lookupReducer,
    providerData: providerReducer,
    lookupReferenceData: lookupReferenceReducer,
    serviceData: serviceReducer
});
